// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"218":"e75d1cc0be0911af3bfb","250":"1bb2fdf8b23963c176f2","666":"432761b9be21b9742bdd","691":"b2c07e8f0e3a697bb33d","774":"b17b885585df338a7da5"}[chunkId] + ".js";
};